// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove spin buttons no Chrome, Safari e navegadores baseados em WebKit */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Remove spin buttons no Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

/* Remove spin buttons no Microsoft Edge (versões antigas) */
input[type="number"] {
  -ms-appearance: textfield;
}

/* Remove spin buttons para navegadores mais genéricos */
input[type="number"] {
  appearance: textfield;
}
`, "",{"version":3,"sources":["webpack://./src/Componets/inputAcervo.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;AAC5B;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;AACvB","sourcesContent":["/* Remove spin buttons no Chrome, Safari e navegadores baseados em WebKit */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Remove spin buttons no Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* Remove spin buttons no Microsoft Edge (versões antigas) */\ninput[type=\"number\"] {\n  -ms-appearance: textfield;\n}\n\n/* Remove spin buttons para navegadores mais genéricos */\ninput[type=\"number\"] {\n  appearance: textfield;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
